export const getIsCookieSettingsOpen = (state) => state.cookieSettings.open;
